'use client';

import { generatePageNumbers, useSearchParamsObject } from 'common-nextjs';
import React from 'react';
import { Button, generateButtonClassNames } from 'ui';
import PageNumberLink from '~/components/Links/PageNumberLink';
import EllipsisIcon from '~/public/static/svg/EllipsisIcon';
import Butter from '~/typings/services/buttercms';

interface Props {
  meta: Butter.Meta;
  pageSize: number;
  scroll?: boolean;
}

const AppDirButterPagination: React.FC<Props> = ({
  meta,
  pageSize,
  scroll,
}) => {
  const searchParams = useSearchParamsObject<{ page?: string }>();

  const currentPage = Number(searchParams.page) || 1;
  const pages = generatePageNumbers(
    currentPage,
    Math.ceil(meta.count / pageSize),
  );

  return (
    <div className="flex items-center justify-center space-x-2">
      {meta.previous_page ? (
        <PageNumberLink
          className={generateButtonClassNames({
            size: 'tiny',
            variant: 'outlined',
          })}
          pageNumber={meta.previous_page}
          scroll={scroll}
        >
          Prev
        </PageNumberLink>
      ) : (
        <Button size="tiny" variant="outlined" disabled>
          Prev
        </Button>
      )}

      {pages.map((page, i) => {
        if (page === '...') {
          return (
            <EllipsisIcon
              key={`ellipsis-${i}`}
              className="text-slate-green-500"
            />
          );
        }

        return (
          <PageNumberLink
            className={generateButtonClassNames({
              size: 'tiny',
              variant: currentPage === page ? 'contained' : 'outlined',
            })}
            key={page}
            pageNumber={page}
            scroll={scroll}
          >
            {page}
          </PageNumberLink>
        );
      })}

      {meta.next_page ? (
        <PageNumberLink
          className={generateButtonClassNames({
            size: 'tiny',
            variant: 'outlined',
          })}
          pageNumber={meta.next_page}
          scroll={scroll}
        >
          Next
        </PageNumberLink>
      ) : (
        <Button size="tiny" variant="outlined" disabled>
          Next
        </Button>
      )}
    </div>
  );
};

export default AppDirButterPagination;
